<script setup>
import { computed, toRefs } from 'vue';
import { useRoute } from 'vue-router';

const props = defineProps({
  prependIcon: {
    type: String,
    default: '',
  },
  title: {
    type: String,
    default: '',
  },
  value: {
    type: String,
    default: '',
  },
  to: {
    type: String,
    default: '',
  },
  open: {
    type: [Array, null],
    default: () => ([]),
  },
  name: {
    type: [Array, null],
    default: () => ([]),
  },
});

const route = useRoute();

const {
  value,
  name,
} = toRefs(props);

const isActive = computed(() => name.value.includes(route.name));

defineOptions({
  inheritAttrs: false,
});

</script>
<template>
  <v-list-item
    :prepend-icon="prependIcon"
    :title="title"
    :value="value"
    :to="to"
    :active="isActive"
  />
</template>
